import { fraxtal as viemFraxtal } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const fraxtal = {
  displayName: 'Fraxtal',
  runtime: 'evm',
  viemChain: viemFraxtal,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'fraxtal' },
    qnStreams: {
      networkKey: 'fraxtal-mainnet',
    },
  }),
} as const satisfies AllChainConfig<'evm', false>;
